import { put, call } from 'redux-saga/effects';
import { clientCategoryMasterList, clientCategoryMasterAdd, clientCategoryMasterEdit, clientCategoryMasterUpdate, clientCategoryMasterDelete } from '../../../services/settings/superadmin/clientCategoryService';

import * as types from '../../../actions';

export function* clientCategoryMasterListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(clientCategoryMasterList, payload);
      yield put({ type: types.CLIENT_CATEGORY_MASTER_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.CLIENT_CATEGORY_MASTER_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
  }

export function* clientCategoryMasterAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(clientCategoryMasterAdd, payload);
      yield put({ type: types.CLIENT_CATEGORY_MASTER_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.CLIENT_CATEGORY_MASTER_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCategoryMasterEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCategoryMasterEdit, payload);
    yield put({ type: types.CLIENT_CATEGORY_MASTER_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CATEGORY_MASTER_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCategoryMasterUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCategoryMasterUpdate, payload);
    yield put({ type: types.CLIENT_CATEGORY_MASTER_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CATEGORY_MASTER_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCategoryMasterDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCategoryMasterDelete, payload);
    yield put({ type: types.CLIENT_CATEGORY_MASTER_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CATEGORY_MASTER_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}